import { styled } from '@mui/material/styles';
import { Divider } from '@mui/material';

export const StyledDivider = styled(Divider)({
  borderColor: "var(--secondaryTextColor)",
  opacity: 0.5,
  margin: "10px 0",
});

export default StyledDivider